import { ModelYhcKazaiDeliveryPeakSeasonRules } from '../../../fireModels/yhcDataTypes'
import { formatDateForMD } from './YhcEFDatetimeInputs/dateFormatter'

/** 繁忙期ルールが有効か（空オブジェクト等を除外） */
export const hasPeakSeasonRule = (
  rule: ModelYhcKazaiDeliveryPeakSeasonRules | undefined | null,
): rule is ModelYhcKazaiDeliveryPeakSeasonRules => {
  return !!rule?.startDate
}

/** 輸送可能点数の上限があるか（null/未入力は無制限） */
export const hasDeliverableItemCountsLimit = (
  rule: ModelYhcKazaiDeliveryPeakSeasonRules | undefined | null,
): boolean => {
  const count = rule?.deliverableItemCounts
  return count != null && count > 0
}

/** 家財点数が繁忙期の輸送可能点数を超えているか */
export const isDeliverableItemCountsExceeded = (
  rule: ModelYhcKazaiDeliveryPeakSeasonRules | undefined | null,
  itemCount: number,
): boolean => {
  if (!hasDeliverableItemCountsLimit(rule)) return false
  return rule!.deliverableItemCounts! < itemCount
}

/** 移行モーダル用の点数制限 li 内 HTML（上限なしの場合は null） */
export const deliverableItemCountsModalListItemHtml = (
  rule: ModelYhcKazaiDeliveryPeakSeasonRules,
): string | null => {
  if (!hasDeliverableItemCountsLimit(rule)) return null
  return `同一日に同一住所の配送可能数 <span class="bold" style="color: red;">${rule.deliverableItemCounts}点</span> までとなります。`
}
